import { useState } from 'react';
import { Alert, Button, Modal } from 'react-bootstrap';
import * as API from '../services/API';

export default function GalerieImageOrder({ group, isPublic, onSaved }) {
  const [images, setImages] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const close = () => { if (!saving) setImages(null); };
  const move = (index, offset) => {
    setImages(previous => {
      const next = [...previous];
      [next[index], next[index + offset]] = [next[index + offset], next[index]];
      return next;
    });
  };
  const save = () => {
    setSaving(true);
    setError('');
    API.reorderGalerieImagesRequest({ categoryId: group.categoryId, isPublic, ids: images.map(image => image._id) },
      response => {
        onSaved(response.data.ids);
        setSaving(false);
        setImages(null);
      },
      message => { setSaving(false); setError(message || 'Impossible d’enregistrer le classement.'); });
  };
  return <>
    <Button size="sm" variant="outline-dark" className="ms-3"
      onClick={() => { setImages([...group.images]); setError(''); }}>
      Classer les images
    </Button>
    <Modal show={images !== null} onHide={close} size="lg" scrollable backdrop={saving ? 'static' : true} keyboard={!saving}>
      <Modal.Header closeButton={!saving}>
        <Modal.Title>Classer les images — {group.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Utilisez les flèches pour choisir l’ordre d’affichage, puis enregistrez.</p>
        {error && <Alert variant="danger">{error}</Alert>}
        <ol className="list-unstyled mb-0">
          {images?.map((image, index) => <li key={image._id} className="d-flex align-items-center gap-2 border rounded p-2 mb-2">
            <span>{index + 1}.</span>
            <img src={image.image} alt={image.name} style={{ width: 80, height: 60, objectFit: 'contain' }} />
            <span className="flex-grow-1 text-break">{image.name}</span>
            <Button variant="outline-secondary" disabled={saving || index === 0}
              aria-label={`Monter ${image.name}`} onClick={() => move(index, -1)}>↑</Button>
            <Button variant="outline-secondary" disabled={saving || index === images.length - 1}
              aria-label={`Descendre ${image.name}`} onClick={() => move(index, 1)}>↓</Button>
          </li>)}
        </ol>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" disabled={saving} onClick={close}>Annuler</Button>
        <Button disabled={saving} onClick={save}>{saving ? 'Enregistrement…' : 'Enregistrer'}</Button>
      </Modal.Footer>
    </Modal>
  </>;
}
